<template>
  <div class="box login">
    <div class="">
      <div>
        <video
          controls="controls"
          autoplay="autoplay"
          id="myVideo"
          :src="url"
          width="100%"
          height="240px"
          class="video"
        >
          <source :src="url" type="video/mp4" />
        </video>
      </div>
      <div class="tab">
        <!-- <div @click="select(0)" :class="tab == 0 ? 'active' : ''">简介</div> -->
        <div @click="select(0)" :class="tab == 0 ? 'active' : ''">零售</div>
        <div @click="select(2)" :class="tab == 2 ? 'active' : ''">正餐</div>
      </div>
    </div>

    <div class="content">
      <div>
        <div v-for="(category, index) in categoryList" :key="index">
          <div class="title">{{ category.categoryName }}</div>
          <div
            :class="[
              'list',
              { list_active: projectCode == project.projectCode },
            ]"
            v-for="(project, i) in category.trainProjectList"
            :key="i"
            @click="onList(project)"
          >
            <div class="icon">视频</div>
            <div class="list_r">
              <div class="left">
                {{ project.serialNum }}.{{ project.projectName }}
              </div>
              <div class="flex align-center" style="font-size: 12px">
               
                <img
                  src="../assets/images/eye.png"
                  alt=""
                  width="13"
                  height=""
                />
                <span class="pl10 num">{{ project.viewCount }}</span>
                 <span style="padding-left:15px">可以观看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tab: 0,
      idx: 0,
      categoryList: [],
      projectCode: "",
      url:
        "http://v.itheima.com/python/python%E5%9F%BA%E7%A1%80/01-%E8%AF%BE%E7%A8%8B%E4%BB%8B%E7%BB%8D.mp4",
      list: [
        {
          title: "java初相识",
          videoList: [
            {
              id: 1,
              type: 0, //可试看
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
            {
              id: 2,
              type: 0, //可试看
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
            {
              id: 3,
              type: 1,
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
          ],
        },
        {
          title: "变量数据类型和运算符",
          videoList: [
            {
              id: 4,
              type: 1, //可试看
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
            {
              id: 5,
              type: 1, //可试看
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
            {
              id: 6,
              type: 1,
              fileType: 1, //文件类型video
              url:
                "https://baijiahao.baidu.com/s?id=1698150762031810955&wfr=content",
              info: "Editplus下载安装及使用", //介绍
            },
          ],
        },
      ],
    };
  },
  methods: {
    select(e) {
      this.tab = e;
      this.categoryList=[]
      this.queryVideoList();
    },
    onList(e) {
      console.log(e);
      // this.idx = e.id;
      this.url = e.videoUrl;
      this.projectCode = e.projectCode;
      this.updateViewCount(e.id);
    },
    queryVideoList() {
      var that = this;
      var type="sale";
      if(this.tab=='2'){
        type="lunch";
      }

      var params = {
        type:type
      };
      this.$http
        .post("trainProject/queryList", params)
        .then(function (response) {
          // console.log(response);
          if ("200" == response.data.code) {
            var categoryList = response.data.data;
            that.categoryList = categoryList;
            console.log(that.categoryList);
            if (
              categoryList.length > 0 &&
              categoryList[0].trainProjectList.length > 0
            ) {
              that.url = categoryList[0].trainProjectList[0].videoUrl;
              that.projectCode =
                categoryList[0].trainProjectList[0].projectCode;
            }
          }
        });
    },
    updateViewCount(id){
       var that = this;
      var params = {
        id:id
      };
      this.$http
        .post("trainProject/updateViewCount", params)
        .then(function (response) {
          // console.log(response);
          if ("200" == response.data.code) {
           
          }
        });
    }
  },
  created() {
    this.queryVideoList();
  },
};
</script>

<style scoped>
.flex{
  display: flex;
}
.align-center{
  align-items: center;
}
.pl10{
  padding-left: 5px;
}
.box {
  background: #333;
}
.tab {
  display: flex;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 18px 30px 0 30px;
}

.tab div {
  color: #333;
  text-align: center;
  padding: 0 18px 18px 18px;
  flex:1;
}

.active {
  color: #dc5b4a;
  border-bottom: 0.125rem solid #dc5b4a;
}

.content {
  height: calc(100vh - 300px);
  background: #fff;
  overflow-y: auto;
}

.content .title {
  background: #f7f8fc;
  padding: 15px;
  color: #222;
  font-weight: bold;
}

.content .list {
  display: flex;
  padding: 18px 10px;
  background: #fff;
  padding-left: 10px;
}
.list_r {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.list_active {
  padding-left: 10px;
  background: #fbece9 !important;
  color: #e46759 !important;
}
.num{
  color: #666;
}
.list_active .num{
  color: #666;
}
.icon {
  border: 1px solid #333;
  padding: 0 2px;
  font-size: 0.15rem;
  border-radius: 3px;
  margin-right: 10px;
  text-align: center;
}

@media (min-width: 640px) {
  .box {
    padding: 10px 160px;
  }
  .video {
    height: 240px;
  }
}
@media (min-width: 800px) {
  .box {
    padding: 20px 240px;
  }
  .video {
    height: 300px;
  }
}
@media (min-width: 1240px) {
  .box {
    padding: 30px 400px;
  }
  .video {
    height: 360px;
  }
}
@media (min-width: 1640px) {
  .box {
    padding: 30px 600px;
  }
  .video {
    height: 420px;
  }
}
@media (min-width: 1820px) {
  .box {
    padding: 30px 700px;
  }
  .video {
    height: 420px;
  }
}
</style>